module.exports = __webpack_public_path__ + "app/principal/principal-check-config-stats-hBD7JnFH.html";